export default {
  hasPendingDocumentsToAgree: (state) => state.pendingAgreementDocuments.length > 0,
  pendingAgreementDocuments: (state) => state.pendingAgreementDocuments,
  pendingHtmlDocuments: (state) => state.pendingHtmlDocuments,
  agreementError: (state) => state.error
}